$(document).ready(function () {
    if ($(".instagram-widget").length > 0 && $(".myig").length == 0) {
    $("<div class='myig container'><div class='myig-title'><h2><span>" + shopDataLayer.instagram.title + "</span></h2><div class='myig-subtitle'>" + shopDataLayer.instagram.subtitle + "</div><div class='myig-socials'><a href='" + $(".instagram-follow-btn a").attr("href") + "' class='ig-ico'><img src='/user/documents/upload/kodovani/instagram.svg'></a></div></div><div class='myig-posts'></div></div>").insertBefore("#footer");
    $(".instagram-widget > a")
        .filter(function () {
            return /^https:\/\/www\.instagram\.com\/p\/[^/]+\/?$/.test(this.href);
        })
        .slice(0, 6)
        .appendTo(".myig-posts");
    }
    if($("#footer #formNewsletterWidget").length){
        $(".custom-footer__newsletter h3").html(shopDataLayer.footer.newsletter.title);
        $("<div class='mynewsletter-subtitle'>" + shopDataLayer.footer.newsletter.subtitle + "</div>").insertAfter(".custom-footer__newsletter h3");
        $(".custom-footer__newsletter button").html(shopDataLayer.footer.newsletter.btnText);
        $(".custom-footer__newsletter").addClass("container").prependTo("#footer");

        // Labely jsou skryté — text labelu do placeholderu (jazykově nezávislé)
        $("#formNewsletterWidget .smart-label-wrapper input").each(function () {
            if (!$(this).attr("placeholder")) {
                $(this).attr("placeholder", $.trim($("#formNewsletterWidget label[for='" + this.id + "']").text()));
            }
        });
    }
    // Captcha newsletteru se odkryje, až člověk začne psát e-mail
    if ($("#formNewsletterWidget [name='captcha']").length) {
        const $newsletterForm = $("#formNewsletterWidget");

        function openNewsletterCaptcha() {
            $newsletterForm.addClass("newsletter--captcha-open");
        }

        function checkNewsletterEmail() {
            if ($newsletterForm.find("[name='email']").val()) {
                openNewsletterCaptcha();
            }
        }

        $(document).on("input change", "#formNewsletterWidget [name='email']", checkNewsletterEmail);
        $(document).on("focusin", "#formNewsletterWidget [name='captcha']", openNewsletterCaptcha);
        document.addEventListener("ShoptetValidationError", function (e) {
            if ($(e.target).is("#formNewsletterWidget [name='captcha']")) {
                openNewsletterCaptcha();
            }
        });
        $(window).on("pageshow", checkNewsletterEmail);
        checkNewsletterEmail();
    }
    if($(window).width() < 500){
        $(".custom-footer").addClass("footer-accordion");
        $(".custom-footer > div:has(h3, h4)").each(function(){
            var $block = $(this), $heading = $block.find("h3, h4").first(), $content = $heading.nextAll();
            $content.hide();
            $heading.addClass("footer-accordion-toggle").on("click", function(){ $content.slideToggle(350); $(this).toggleClass("is-open"); });
        });
    }
    $("<span class='remedio'>" + shopDataLayer.footer.signature + "</span>").prependTo("#signature");
    $("#signature .title").html("Shoptet");
});